import { render, staticRenderFns } from "./CustomerTypeForm.vue?vue&type=template&id=128efa62&"
import script from "./CustomerTypeForm.vue?vue&type=script&lang=js&"
export * from "./CustomerTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports